import { render, staticRenderFns } from "./processing-list.vue?vue&type=template&id=3bea4ca9"
import script from "./processing-list.vue?vue&type=script&lang=js"
export * from "./processing-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports